import React, { Component } from "react";
import { connect } from "react-redux";
import { loginCustomer } from "../../store/actions/customer";
import PageTitle from "../../components/shared/PageTitle";
import styles from "../../thema/style";

class CheckoutLogin extends Component {
  state = {
    errors: [],
    email: "",
    password: ""
  };

  renderErrorMessage() {
    if (this.props.customer.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.props.customer.errors.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    if (!this.state.password) errors.push("Şifreniz alanı boş bırakılamaz!");
    return errors;
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    var errors = this.validate();
    this.setState({ errors: errors });
    if (errors.length === 0) {
      this.props.loginCustomer({ ...this.state }, "/odeme");
    }
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle title={"Kasaya Git"} />
        <div className="row">
          <div className={"col-md-10 offset-md-1"}>
            <div className={styles.loginBox}>
              <div className={"overlay-content"} />
              <div className={"tab-content"}>
                <div className={"row"}>
                  <div className={"col-md-5"}>
                    <h3>Üye Girişi Yap</h3>
                    <form onSubmit={this.onSubmit}>
                      <div className={"clearfix large_form"}>
                        <input
                          type="email"
                          name="email"
                          placeholder="E-mail Adresiniz"
                          defaultValue={this.state.email}
                          onChange={e => {
                            this.handleChange(e);
                          }}
                          required
                        />
                      </div>
                      <div className={"clearfix large_form"}>
                        <input
                          type="password"
                          name="password"
                          placeholder="Şifreniz"
                          onChange={e => {
                            this.handleChange(e);
                          }}
                          required
                        />
                      </div>

                      <div className={"clearfix large_form text-right"}>
                        <a className={"forgot-password"} href="#">
                          Şifremi Unuttum
                        </a>
                      </div>
                      <div className={"clearfix large_form text-left"}>
                        <button type="submit">GİRİŞ YAP</button>
                        {this.renderErrorMessage()}
                      </div>
                    </form>
                  </div>
                  <div className={"col-md-1"}>
                    <div
                      style={{
                        height: "100%",
                        display: "block",
                        border: "0.5px solid rgba(113, 144, 56, 0.4)",
                        width: 1,
                        margin: "auto"
                      }}
                    />
                  </div>
                  <div className={"col-md-6"}>
                    <h3>Üye Değilmisiniz</h3>
                    <p>
                      Hızlı ve güvenli bir alışveriş için yeni bir hesap
                      oluşturun. Böylece sipariş durumunuzu takip edebilir ve
                      önceki siparişlerinize göz atabilirsiniz.
                    </p>
                    <p>
                      Üyelik ile sipariş takibi kolaylığı ve hızlı alışveriş
                      imkanı sağlanmış olur.
                    </p>
                    <p>
                      Sipariş verebilmek için misafir olarak da devam
                      edebilirsiniz. E-Mail adresinize sipariş bilgileriniz
                      gönderilir.
                    </p>
                    <p className={"text-right"}>
                      <button
                        className={styles.buttonDark}
                        type="button"
                        onClick={e => {
                          e.preventDefault();
                          this.props.history.push({
                            pathname: "/odeme",
                            state: {
                              location: "/odeme"
                            }
                          });
                        }}
                      >
                        ÜYE OLMADAN DEVAM ET
                      </button>
                      <button
                        className={styles.buttonDefault}
                        type="button"
                        onClick={e => {
                          e.preventDefault();
                          this.props.history.push({
                            pathname: "/uye-ol",
                            state: {
                              location: "/odeme"
                            }
                          });
                        }}
                      >
                        ÜYE OL
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { loginCustomer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutLogin);



// WEBPACK FOOTER //
// ./src/routers/Checkout/login.js